import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {UtilsService} from 'src/app/shared/utils/utils.service';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';
import {DatosMaestrosService} from 'src/app/services/datos-maestros.service';
import {ReglasOperacionBancariaService} from '../../../services/reglas-banca/reglas-banca.service';
import {moduloConciliacionBan} from '../../../diccionarios/conciliacionBancariaModulo';
import {ReglaOpBanca} from '../../../models/conciliacionbancaria/reglaOpBanca';


@Component({
  selector: 'app-reglas-operacion-banca',
  templateUrl: './reglas-operacion-banca.component.html',
  styleUrls: ['./reglas-operacion-banca.component.css']
})
export class ReglasOperacionBancaComponent implements OnInit {

  textBoton: string;
  tvcModulo: any;
  DAT_BTNCSS: any;
  DAT_BTNS: any;
  DAT_MSG: any;

  formulario: FormGroup;
  formularioPlanta: FormGroup;

  columnDefs: any[];
  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  rowSelection: any;
  textoBuscar: string;


  cmbEmpresa: any[] = [];
  cmbPersona: any[] = [];
  cmbSigno: any[] = [{id: '+', descripcion: 'Positivo'}, {id: '-', descripcion: 'Negativo'}];
  cmbBancos: any[] = [];

  loading: boolean = false;
  loadingPp: boolean = false;
  listaVaciaPp: boolean = true;
  listaVacia: boolean;

  dataUsuario: any = {username: '', id: null};
  dataUsuarioDestino: any = {username: '', id: null};

  mostrarFormulario: string;
  MOSTRAR_GRID: string = 'MOSTRAR_GRID';
  MOSTRAR_ADD_PLANTA: string = 'MOSTRAR_ADD_PLANTA';
  MOSTRAR_ENVIAR_PLANTAS: string = 'MOSTRAR_ENVIAR_PLANTAS';

  editableForm = false;
  listaVaciaClon: boolean;
  loadingSeg: boolean;
  banderaClon: any = false;

  diccionarioModulo: any;

  reglaOperacionBancaEdit: ReglaOpBanca;
  URI: string = 'PLANTA PERSONA';

  constructor(
    private fb: FormBuilder,
    private servicioUtils: UtilsService,
    private _reglasOpBanca: ReglasOperacionBancariaService,
    private _datosMaestros: DatosMaestrosService) {

    this.DAT_BTNCSS = moduloConciliacionBan.button.buttonsCss;
    this.DAT_BTNS = moduloConciliacionBan.button.buttonsNombre;
    this.DAT_MSG = moduloConciliacionBan.mensajes;
    this.mostrarFormulario = this.MOSTRAR_GRID;
    this.diccionarioModulo = moduloConciliacionBan;
    this.textBoton = 'HOLA';
    this.formulario = this.fb.group({
      id: [''],
      refBanco: ['', [Validators.required, Validators.maxLength(5)]],
      empresa: [''],
      idBanco: [''],
      codBanco: ['', [Validators.required, Validators.maxLength(250)]],
      tcTipoTransaccion: ['', [Validators.required, Validators.maxLength(4)]],
      descripcionConcepto: ['', [Validators.required, Validators.maxLength(250)]],
      signo: ['', [Validators.required, Validators.maxLength(1)]],
      operacionInternaSap: ['', [Validators.required, Validators.maxLength(3)]],
      tipo: ['', [Validators.required, Validators.maxLength(2)]],
      tipoMov: ['', [Validators.required, Validators.maxLength(30)]]
    });
  }

  ngOnInit() {
    this.servicioUtils.calcularHorasLogout();
    this.gridComponent();
    //this.gridComponentPlantaPersona();
    this.getAllReglaOperacionBanca();
    this.cargarEmpresa();
  }

  // *COMPONENTES GRID
  gridComponent() {
    this.columnDefs = [
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.editReglaOpBanca.bind(this),
          label: 'Editar',//this.tvcModulo.button.buttonsNombre.editar,
          colorBoton: this.DAT_BTNCSS.info
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        cellRendererParams: {
          onClick: this.eliminarSegmento.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger
        }
      },
      {
        headerName: 'ID',
        field: 'id',
        sortable: true,
        filter: true,
        width: 80
      },
      {
        headerName: 'Ref. Bancaria',
        field: 'refBanco',
        sortable: true,
        filter: true,
        width: 180
      },
      {
        headerName: 'Codigo Banco',
        field: 'codBanco',
        resizable: true,
        sortable: true,
        filter: true,
        width: 300
      },
      {
        headerName: 'Tc Tipo Tranc.',
        field: 'tcTipoTransaccion',
        resizable: true,
        sortable: true,
        filter: true,
        width: 200
      },
      {
        headerName: 'Desc. Concepto',
        field: 'descripcionConcepto',
        resizable: true,
        sortable: true,
        filter: true,
        width: 300
      },
      {
        headerName: 'Signo',
        field: 'signo',
        sortable: true,
        filter: true,
        width: 150
      },
      {
        headerName: 'Op Interna Sap',
        field: 'operacionInternaSap',
        sortable: true,
        filter: true,
        width: 180
      },
      {
        headerName: 'Tipo',
        field: 'tipo',
        sortable: true,
        filter: true,
        width: 180
      },
      {
        headerName: 'Tipo Movimiento',
        field: 'tipoMov',
        sortable: true,
        filter: true,
        width: 300
      }
    ];
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }


  // * FUNCIONES
  agrgarPlanta({rowData}) {
    this.banderaClon = false;
    this.mostrarFormulario = this.MOSTRAR_ADD_PLANTA;
    this.textBoton = this.tvcModulo.button.buttonsNombre.guardar;
    this.dataUsuario.username = rowData.idUsuario;
    this.dataUsuario.id = rowData.id;
    this.formulario.get('persona_id').setValue(rowData.id);
    //this.getPlantaPersonaUsuario(rowData.idUsuario);
  }

  editReglaOpBanca({rowData}) {
    this.banderaClon = true;
    this.listaVaciaClon = true;
    this.mostrarFormulario = this.MOSTRAR_ENVIAR_PLANTAS;
    this.textBoton = this.DAT_BTNS.guardar;
    this.cmbBancos = [{idBanco: rowData.codBanco, dscaEmpresa: rowData.codBanco}];
    this.formulario.get('refBanco').setValue(rowData.refBanco);
    this.formulario.get('codBanco').setValue(rowData.codBanco);
    this.formulario.get('tcTipoTransaccion').setValue(rowData.tcTipoTransaccion);
    this.formulario.get('descripcionConcepto').setValue(rowData.descripcionConcepto);
    this.formulario.get('signo').setValue(rowData.signo);
    this.formulario.get('operacionInternaSap').setValue(rowData.operacionInternaSap);
    this.formulario.get('tipo').setValue(rowData.tipo);
    this.formulario.get('tipoMov').setValue(rowData.tipoMov);
    this.formulario.get('empresa').setValue('1001');
    this.formulario.get('idBanco').setValue('refBanco');//
    this.cargarBancoEmpresa();
    this.reglaOperacionBancaEdit = {
      id: rowData.id,
      refBanco: rowData.refBanco,
      codBanco: rowData.codBanco,
      tcTipoTransaccion: rowData.nomSegmento,
      descripcionConcepto: rowData.descripcionConcepto,
      signo: rowData.signo,
      operacionInternaSap: rowData.operacionInternaSap,
      tipo: rowData.tipo,
      tipoMov: rowData.tipoMov
    }
    //this.getPlantaPersonaUsuario(rowData.idUsuario);
  }

  eliminarSegmento({rowData}) {
    this.servicioUtils.confirmarSincronoPromesaNormal(
      {
        title: this.DAT_MSG.eliminar,
        text: '',
        action: this.DAT_BTNS.eliminar,
        funcion: this._reglasOpBanca.deteleParametros(rowData.id),
        loading: true,
        tagLoading: 'loadingSeg',
        context: this,
      }
    ).then((res: any) => {
      this.rowData = this.rowData.filter(item => item.id !== rowData.id);
      //this.formulario.reset();
      //this.getAllSegmentos();
      //this.mostrarFormulario = this.MOSTRAR_GRID;
    }).catch((err) => {
      this.servicioUtils.mensajeErrorVisto(err.error.mensaje);
    });
  }

  acciones(event) {
    console.log(event);
    if (event === 'editarSeg') {
      this.editarReglaOpBanca();
    } else if (event === 'save') {
      this.guardarReglaOpBanca();
    } else {
      this.dataUsuario.username = '';
      this.dataUsuario.id = null;
      this.formulario.reset();
      this.mostrarFormulario = this.MOSTRAR_GRID;
    }
  }

  agregarReglaOpBanca() {
    //console.log(rowData);
    this.banderaClon = true;
    //this.gridComponentPlantaPersona();
    this.listaVaciaClon = true;
    this.mostrarFormulario = this.MOSTRAR_ADD_PLANTA;
    this.textBoton = 'Guardar';
    this.cargarEmpresa();
  }

  getAllReglaOperacionBanca() {
    this.loading = true;
    this.listaVacia = true;
    this._reglasOpBanca.getAll().subscribe((respuesta: any[]) => {
      this.loading = false;
      this.rowData = respuesta.sort((a, b) => (a.id > b.id) ? 1 : -1);
      this.listaVacia = (this.rowData.length === 0) ? true : false;
    }, (err: any) => {
      this.listaVacia = true;
      this.rowData = [];
      this.loading = false;
      console.log(err);
    });
  }


  cargarEmpresa() {
    // this._paramConciBanca.getAllEmpresa().subscribe((resp) => {
    this._datosMaestros.getAllEmpresas().subscribe((resp) => {
      console.log(resp);
      this.cmbEmpresa = resp;
      this.formulario.get('empresa').setValue("1001");
      console.log(this.formulario.get('empresa').value);
      this.cargarBancoEmpresa();
    }, (error) => {
      this.cmbEmpresa = [];
      console.log(error);
    });
  }

  elegirBanco() {
    const banco = this.cmbBancos.find(item => item.idBanco === this.formulario.get('idBanco').value);
    console.log(banco);
    this.formulario.get('refBanco').setValue(banco.refBanco);
  }

  cargarBancoEmpresa() {
    //console.log(this.formulario.get('empresa').value);
    // this._paramConciBanca.getBancoPorEmpresa(inIdEmpresa).subscribe((resp) => {
    this._datosMaestros.getBancoPorEmpresa(this.formulario.get('empresa').value).subscribe((resp) => {
      console.log(resp);
      this.cmbBancos = this.concatenarBancoId(resp);
      if (this.formulario.get('idBanco').value !== undefined)
        this.formulario.get('idBanco').setValue(this.formulario.get('idBanco').value);
    }, (error) => {
      this.cmbBancos = [];
      console.log(error);
    });
  }

  concatenarBancoId(data: any[]) {
    return data = data.map(e => {
      let newDscaBanco = e.idBanco + ' - ' + e.dscaBanco;
      delete e['dscaBanco'];
      e.dscaBanco = newDscaBanco;
      return e;
    });
  }

  guardarReglaOpBanca() {

    /*const elemento = this.rowData.find((e: Segmento) => e.id === id);
    if(elemento !== undefined){
      this.servicioUtils.mensajeErrorVisto("Identificador ya en uso, por favor usar otro",true,10000);
      return;
    } */

    const reglaOp: ReglaOpBanca = {
      refBanco: this.formulario.get('refBanco').value,
      codBanco: this.formulario.get('codBanco').value,
      tcTipoTransaccion: this.formulario.get('tcTipoTransaccion').value,
      descripcionConcepto: this.formulario.get('descripcionConcepto').value,
      signo: this.formulario.get('signo').value,
      operacionInternaSap: this.formulario.get('operacionInternaSap').value,
      tipo: this.formulario.get('tipo').value,
      tipoMov: this.formulario.get('tipoMov').value
    };

    this.servicioUtils.confirmarSincronoPromesaNormal(
      {
        title: this.DAT_MSG.guardar,
        text: '',
        action: this.DAT_BTNS.guardar,
        funcion: this._reglasOpBanca.guardarParametros(reglaOp),
        loading: true,
        tagLoading: 'loadingSeg',
        context: this,
      }
    ).then((res: any) => {
      this.formulario.reset();
      this.getAllReglaOperacionBanca();
      this.mostrarFormulario = this.MOSTRAR_GRID;
      //this.getPlantaPersonaUsuarioClon(this.dataUsuarioDestino.username);
    }).catch((err) => {
      this.servicioUtils.mensajeErrorVisto(err.error.mensaje);
    });
  }

  editarReglaOpBanca() {
    this.reglaOperacionBancaEdit.refBanco = this.formulario.get('refBanco').value;
    this.reglaOperacionBancaEdit.codBanco = this.formulario.get('codBanco').value;
    this.reglaOperacionBancaEdit.tcTipoTransaccion = this.formulario.get('tcTipoTransaccion').value;
    this.reglaOperacionBancaEdit.descripcionConcepto = this.formulario.get('descripcionConcepto').value;
    this.reglaOperacionBancaEdit.operacionInternaSap = this.formulario.get('operacionInternaSap').value;
    this.reglaOperacionBancaEdit.signo = this.formulario.get('signo').value;
    this.reglaOperacionBancaEdit.tipo = this.formulario.get('tipo').value;
    this.reglaOperacionBancaEdit.tipoMov = this.formulario.get('tipoMov').value;

    this.servicioUtils.confirmarSincronoPromesaNormal(
      {
        title: this.DAT_MSG.actualizar,
        text: '',
        action: this.DAT_BTNS.actualizar,
        funcion: this._reglasOpBanca.actualizar(this.reglaOperacionBancaEdit),
        loading: true,
        tagLoading: 'loadingSeg',
        context: this,
      }
    ).then((res: any) => {
      this.formulario.reset();
      this.getAllReglaOperacionBanca();
      this.mostrarFormulario = this.MOSTRAR_GRID;
      //this.getPlantaPersonaUsuarioClon(this.dataUsuarioDestino.username);
    }).catch((err) => {
      this.servicioUtils.mensajeErroToast(err.error.mensaje);
    });
  }


  eliminarClon({rowData}) {
    this.servicioUtils.confirmarSincronoPromesaNormal(
      {
        title: this.tvcModulo.mensajes.eliminar,
        text: '',
        action: this.tvcModulo.button.buttonsNombre.eliminar,
        funcion: this._reglasOpBanca.deteleParametros(rowData.id),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.rowData = this.rowData.filter(item => item.id !== rowData.id);
    }).catch((err) => {
      this.servicioUtils.mensajeErrorVisto(err.error.mensaje);
    });
  }
}
